<template>
  <div id="app">
    <router-view/>
    <CartBar v-if="$route.path !== '/home' && $route.path !== '/media-entry' && !$route.path.startsWith('/user-center')" />
    <CollectFolderDialog />
  </div>
</template>

<script>
import CartBar from '@/components/CartBar.vue'
import CollectFolderDialog from '@/components/CollectFolderDialog.vue'
import { getAuthInfo } from '@/api'
export default {
  name: 'App',
  components: { CartBar, CollectFolderDialog },
  async created() {
    const token = localStorage.getItem('token')
    if (token) {
      try {
        const user = await getAuthInfo()
        this.$store.commit('SET_USER', user)
        this.$store.dispatch('fetchCart')
        this.$store.dispatch('fetchCollect')
        this.$store.dispatch('fetchFolders')
      } catch (e) {
        this.$store.commit('CLEAR_TOKEN')
      }
    }
  }
}
</script>

<style>
/* ============ 苹果风设计变量 ============ */
:root {
  --primary: #0071e3;
  --primary-dark: #0060c0;
  --primary-hover: #0077ed;
  --primary-light: rgba(0, 113, 227, 0.08);
  --danger: #ff3b30;
  --success: #34c759;
  --warning: #ff9500;
  --bg-page: #f5f5f7;
  --bg-card: #ffffff;
  --text-primary: #1d1d1f;
  --text-regular: #3a3a3c;
  --text-secondary: #6e6e73;
  --text-disabled: #aeaeb2;
  --border-color: rgba(0, 0, 0, 0.08);
  --border-light: rgba(0, 0, 0, 0.05);
  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.04);
  --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.06);
  --shadow-lg: 0 12px 32px rgba(0, 0, 0, 0.08);
  --shadow-xl: 0 20px 60px rgba(0, 0, 0, 0.12);
  --radius-sm: 8px;
  --radius-md: 12px;
  --radius-lg: 18px;
  --radius-full: 999px;
  --nav-height: 60px;
  --transition-fast: 0.2s ease;
  --transition-normal: 0.3s ease;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'PingFang SC',
    'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text-primary);
  background: var(--bg-page);
  line-height: 1.5;
  padding-top: 60px;
}

::-webkit-scrollbar { width: 6px; height: 6px; }
::-webkit-scrollbar-track { background: transparent; }
::-webkit-scrollbar-thumb { background: #c9cdd4; border-radius: 3px; }
::-webkit-scrollbar-thumb:hover { background: #a8abb2; }

/* ============ Element UI 苹果风全局覆盖 ============ */

/* ---- 按钮 ---- */
.el-button {
  border-radius: 10px;
  font-weight: 500;
  transition: all 0.2s ease;
}
.el-button--primary {
  background: #0071e3;
  border-color: #0071e3;
}
.el-button--primary:hover,
.el-button--primary:focus {
  background: #0077ed;
  border-color: #0077ed;
}
.el-button--primary.is-plain {
  background: rgba(0, 113, 227, 0.06);
  border-color: rgba(0, 113, 227, 0.35);
  color: #0071e3;
}
.el-button--primary.is-plain:hover,
.el-button--primary.is-plain:focus {
  background: rgba(0, 113, 227, 0.12);
  border-color: #0071e3;
  color: #0071e3;
}
.el-button--danger { background: #ff3b30; border-color: #ff3b30; }
.el-button--danger:hover, .el-button--danger:focus { background: #ff5147; border-color: #ff5147; }
.el-button--success { background: #34c759; border-color: #34c759; }
.el-button--success:hover, .el-button--success:focus { background: #3dd364; border-color: #3dd364; }
.el-button--text { color: #0071e3; }
.el-button--text:hover, .el-button--text:focus { color: #0077ed; }
.el-button--large { border-radius: 12px; }
.el-button--small { border-radius: 8px; }

/* ---- 输入框 / 选择器 ---- */
.el-input__inner,
.el-textarea__inner {
  border-radius: 10px;
  border-color: rgba(0, 0, 0, 0.1);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.el-input__inner:hover,
.el-textarea__inner:hover { border-color: rgba(0, 0, 0, 0.18); }
.el-input__inner:focus,
.el-textarea__inner:focus {
  border-color: #0071e3;
  box-shadow: 0 0 0 3px rgba(0, 113, 227, 0.12);
}
.el-select .el-input__inner { border-radius: 10px; }
.el-range-editor { border-radius: 10px; }
.el-date-editor .el-input__inner { border-radius: 10px; }

/* ---- 卡片 ---- */
.el-card {
  border-radius: 18px;
  border: none;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
}

/* ---- 对话框 ---- */
.el-dialog {
  border-radius: 22px;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.2);
}
.el-dialog__header { padding: 24px 28px 12px; }
.el-dialog__title { font-size: 18px; font-weight: 600; color: #1d1d1f; }
.el-dialog__body { padding: 12px 28px 24px; }

/* ---- 消息 / 通知 ---- */
.el-message {
  border-radius: 12px;
  border: none;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
}
.el-message-box {
  border-radius: 20px;
  border: none;
  box-shadow: 0 30px 70px rgba(0, 0, 0, 0.18);
}
.el-notification {
  border-radius: 18px;
  border: none;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.14);
}

/* ---- 下拉菜单 ---- */
.el-dropdown-menu {
  border-radius: 14px;
  border: none;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
  padding: 6px;
}
.el-dropdown-menu__item { border-radius: 8px; color: #3a3a3c; }
.el-dropdown-menu__item:not(.is-disabled):hover,
.el-dropdown-menu__item:focus { background: rgba(0, 113, 227, 0.08); color: #0071e3; }

/* ---- 表格 ---- */
.el-table { border-radius: 14px; color: #3a3a3c; }
.el-table th.el-table__cell {
  background: #fafafa;
  color: #1d1d1f;
  font-weight: 600;
}
.el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
  background: #fafafa;
}
.el-table td.el-table__cell { border-bottom: 1px solid rgba(0, 0, 0, 0.05); }

/* ---- 分页 ---- */
.el-pagination { font-weight: 500; }
.el-pagination button, .el-pager li {
  border-radius: 8px;
  transition: all 0.2s ease;
}
.el-pager li.active { background: #0071e3; color: #fff; border-radius: 8px; }
.el-pager li:hover { color: #0071e3; }

/* ---- 标签 ---- */
.el-tag { border-radius: 6px; }
.el-tag--primary { background: rgba(0, 113, 227, 0.08); border-color: rgba(0, 113, 227, 0.2); color: #0071e3; }

/* ---- Tabs ---- */
.el-tabs__item { color: #6e6e73; font-weight: 500; }
.el-tabs__item:hover { color: #3a3a3c; }
.el-tabs__item.is-active { color: #0071e3; }
.el-tabs__active-bar { background: #0071e3; height: 3px; border-radius: 2px; }

/* ---- 表单 ---- */
.el-form-item__label { color: #3a3a3c; font-weight: 500; }
.el-form-item__error { color: #ff3b30; }

/* ---- 单选 / 复选 ---- */
.el-radio__input.is-checked .el-radio__inner { background: #0071e3; border-color: #0071e3; }
.el-radio__input.is-checked + .el-radio__label { color: #0071e3; }
.el-checkbox__input.is-checked .el-checkbox__inner { background: #0071e3; border-color: #0071e3; }
.el-checkbox__input.is-checked + .el-checkbox__label { color: #0071e3; }

/* ---- 步骤条 ---- */
.el-steps .el-step__title.is-process { color: #1d1d1f; font-weight: 600; }
.el-step__head.is-process { color: #0071e3; border-color: #0071e3; }
.el-step__head.is-finish { color: #0071e3; border-color: #0071e3; }
.el-step__title.is-finish { color: #0071e3; }

/* ---- 加载 / 提示 ---- */
.el-loading-mask { border-radius: inherit; }
.el-tooltip__popper.is-dark { background: #1d1d1f; border-radius: 8px; }
.el-popper[x-placement^='top'] .popper__arrow { border-top-color: transparent; }

/* ---- 抽屉 ---- */
.el-drawer { border-radius: 24px 0 0 24px; }
</style>